import { useNavigate } from 'react-router-dom';
import { LoginWithMobileOTPForm } from '../components';
import { AuthLayout } from '@/components/Layout';

export const LoginWithMobileOTP = () => {
  const navigate = useNavigate();

  return (
    <AuthLayout page="login-with-mobile-otp">
      <LoginWithMobileOTPForm
        onSuccess={() => {
          navigate('/');
        }}
      />
    </AuthLayout>
  );
};
